import { render, staticRenderFns } from "./FormSchemaBuilder.vue?vue&type=template&id=72bbe298&"
import script from "./FormSchemaBuilder.vue?vue&type=script&lang=js&"
export * from "./FormSchemaBuilder.vue?vue&type=script&lang=js&"
import style0 from "./FormSchemaBuilder.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports